import React from 'react'
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox } from '@material-ui/core';

const Checkbox = (props) => {

    const { name, label, value, onChange, disabled } = props;


    const convertToDefEventPara = (name, value) => ({
        target: {
            name, value
        }
    });

    return (
        <FormControl>
            <FormControlLabel
                control={<MuiCheckbox
                    name={name}
                    color="primary"
                    checked={value}
                    disabled={disabled}
                    onChange={e => onChange(convertToDefEventPara(name, e.target.checked))}
                />}
                label={label}
            />
        </FormControl>
    )
};

export default Checkbox;
